<template>
  <v-dialog
    v-model="showDialogRegister"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
    z-index="1400"
    :retain-focus="false"
  >
    <template v-slot:activator="{}">
      <span
        v-if="isTextButton && !hideDialogRegisterButtons"
        class="primary--text text-body-1 font-weight-bold"
        @click="openDialog"
        style="cursor: pointer;"
      >
        {{ $t("newCasino.search.createAnAccount") }}
      </span>
      <v-btn
        v-else-if="!hideDialogRegisterButtons"
        id="btn_register_dialog"
        class="mx-1 darken-1 caption"
        :class="$vuetify.breakpoint.mdAndDown ? 'px-2' : ''"
        color="primary"
        :disabled="$route.name == 'Register'"
        @click="openDialog"
      >
        {{ $t("register") }}
      </v-btn>
    </template>

    <NewRegisterForm v-if="$isCreditOnline()" :urlRedirect="urlRedirect" />
    <RegisterForm v-else :urlRedirect="urlRedirect" />
  </v-dialog>
</template>
<script>
import RegisterForm from "@/views/home/register";
import NewRegisterForm from "@/views/home/register/newRegisterForm";

export default {
  name: "dialog-register",
  components: {
    RegisterForm,
    NewRegisterForm,
  },
  props: [
    "idDialog",
    "urlRedirect",
    "isTextButton",
    "hideDialogRegisterButtons",
  ],
  computed: {
    showDialogRegister() {
      // idDialog serve para não abrir 2 ou mais dialogs ao mesmo tempo
      if (this.idDialog == "general") {
        this.$store.commit("showDialogRegisterByIdDialog", "");

        return this.$store.state.showDialogRegister;
      } else if (this.idDialog == this.showDialogRegisterByIdDialog) {
        return this.$store.state.showDialogRegister;
      }
      return false;
    },
  },
  methods: {
    openDialog() {
      const onJogoDeOuroDomains = ["bet24hs", "chutaco", "sportebet", "soccer888", "nordestefutebol", "apostamaster", "betclub7", "attack"];

      if (onJogoDeOuroDomains.includes(this.$domain())) {
        window.location = "https://jogodeouro.bet/pt/sports#/overview";
      } else {
        this.$store.commit("showDialogRegisterByIdDialog", this.idDialog);

        this.$store.commit("showDialogRegister", true);
      }
    },
  },
};
</script>
